import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import * as actions from '../actions'
import { compose } from '../common/utils'
import * as API from '../services/api'
import * as qs from 'qs'
import { Button, Alert } from 'antd'
import './login.less'

class AuthorizePage extends React.Component {
  state = {
    mode: null,
    isSubmitting: false,
    errMsg: null
  }

  authorizeParams = (params) => {
    this.setState({ errMsg: null })
    return API.authorizeToken(params.userId, params.token).then(res => {
      if (res.expired) {
        if (res.canResend) {
          this.setState({ mode: 'email', expiredToken: params.token })
        } else {
          this.setState({ errMsg: 'Your link has expired.' })
        }
      } else {
        this.props.setUserInfo({ userId: params.userId, redirectTo: params.redirectTo, customerName: res.customerName, token: params.token })
        this.props.history.push(`${params.redirectTo}`)
      }
    },
      e => {
        this.setState({ errMsg: e.message })
      })
  }

  authorizeResend = () => {
    this.setState({ isSubmitting: true, errMsg: null })
    return API.authorizeResend(this.props.user.userId, this.props.user.redirectTo, this.state.expiredToken).then(res => {
      this.setState({ isSubmitting: false, mode: 'email_sent' })
    },
      e => {
        this.setState({ isSubmitting: false })
        this.setState({ errMsg: e.message })
      })
  }

  parseQueryParams = (props) => {
    const { history } = props
    const search = history.location.search && history.location.search.replace(/\?/g, '')
    const params = qs.parse(search)

    if (!params.token || !params.redirectTo) {
      return
    }

    return {
      token: params.token,
      userId: params.userId,
      redirectTo: params.redirectTo
    }
  }

  componentDidMount() {
    const params = this.parseQueryParams(this.props)
    if (params) {
      this.props.setUserInfo({ userId: params.userId, redirectTo: params.redirectTo })
      this.authorizeParams(params)
    } else if (this.props.user.userId) {
      this.authorizeParams(this.props.user)
    }
  }

  render() {
    const { errMsg } = this.state

    return (
      <div className="login-container">
        <div className="login-inner">

          {/* <div className="image logo">
            <img src="synkedup-light.png" alt="Synkedup logo" />
          </div> */}

          {this.state.mode === 'email'
            ? (
              <div>
                <h1>This link has expired</h1>
                <h3>Re-send an authorization link via email</h3>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                  loading={this.state.isSubmitting}
                  onClick={this.authorizeResend}
                >
                  Re-send link
                </Button>
              </div>
            ) : null}

          {this.state.mode === 'email_sent'
            ? (
              <div>
                <h3>Email successfully sent</h3>
              </div>
            ) : null}

          {errMsg && errMsg.length
            ? <div>
              <div className="error-message">
                <Alert message={errMsg} type="error" showIcon />
              </div>
            </div>
            : null}

        </div>
      </div>
    )
  }
}

export default compose(
  connect(
    state => ({
      user: state.userInfo
    }),
    dispatch => bindActionCreators({ ...actions }, dispatch)
  ),
  withRouter
)(AuthorizePage)
